import { useState } from "react";
import { toast } from "sonner";
import { Building2, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Which rooftop gets this unit's leads. Auto (rules) or pinned by hand; "Unassigned" routes to the group default.
export function StoreChip({ vehicle: v, stores, onSaved }) {
  const [busy, setBusy] = useState(false);
  if (!stores?.length) return null;
  const store = stores.find((s) => s.id === v.store_id);
  const set = async (val) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/vehicles/${v.id}/store`, { store_id: val === "auto" ? null : val });
      onSaved?.(data);
      const to = stores.find((s) => s.id === data.store_id);
      toast.success(val === "auto" ? (to ? `Back to rules → ${to.name}` : "Back to rules → unassigned") : `Pinned to ${to?.name}`);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  const label = store ? store.name : "Unassigned";
  const src = v.store_source === "manual" ? "pinned" : v.store_source === "location" ? "website location" : v.store_source === "stock_rule" ? "stock #" : "no rule matched";
  return (
    <Select value={v.store_source === "manual" ? v.store_id : "auto"} onValueChange={set} disabled={busy}>
      <SelectTrigger
        data-testid={`store-chip-${v.id}`}
        title={`Leads route to: ${label} (${src})`}
        className={`h-7 px-2 gap-1 text-[11px] font-semibold border rounded-md w-auto max-w-[60%] ${
          store ? "border-[#0A8CF2]/50 bg-[#0A8CF2]/10 text-[#7FC3FF]" : "border-amber-500/70 bg-amber-950/40 text-amber-300"
        }`}
      >
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Building2 className="h-3 w-3 shrink-0" />}
        <SelectValue asChild><span className="truncate">{label}{v.store_source === "manual" ? " · pinned" : ""}</span></SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-[#12141C] border-[#2A2E3D] text-slate-200">
        <SelectItem value="auto">Automatic (rules)</SelectItem>
        {stores.map((s) => <SelectItem key={s.id} value={s.id}>Pin to {s.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
